// This file is generated by `gulp generate-api`
'use strict';

exports.__esModule = true;
exports['default'] = apiReducer;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj['default'] = obj;
    return newObj;
  }
}

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _APIQuery = require('./APIQuery');

var _APIQuery2 = _interopRequireDefault(_APIQuery);

var _immutable = require('immutable');

var InitialState = _immutable.Record({
  fetch: _immutable.fromJS({
    application: {
      constraints: {
        query: _APIQuery2['default']({})
      },
      // getIn(['fetch', 'application', 'firstLoanOffer', ]) APIQuery(fetchApplicationFirstLoanOffer)
      firstLoanOffer: {}
    },
    client: {
      additionalData: {
        query: _APIQuery2['default']({})
      },
      application: {
        constraints: {
          query: _APIQuery2['default']({})
        },
        // getIn(['fetch', 'client', 'application', 'monthlyPayment', ]) APIQuery(fetchClientApplicationMonthlyPayment)
        monthlyPayment: {},
        // getIn(['fetch', 'client', 'application', 'offer', ]) APIQuery(fetchClientApplicationOffer)
        offer: {},
        query: _APIQuery2['default']({})
      },
      bankAccountNumber: {
        query: _APIQuery2['default']({})
      },
      banks: {
        query: _APIQuery2['default']({})
      },
      consents: {
        query: _APIQuery2['default']({})
      },
      email: {
        query: _APIQuery2['default']({})
      },
      identityDocument: {
        query: _APIQuery2['default']({})
      },
      // getIn(['fetch', 'client', 'loans', loanId(?)]) APIQuery(fetchClientLoansByLoanid)
      loans: {},
      phone: {
        query: _APIQuery2['default']({})
      },
      profile: {
        query: _APIQuery2['default']({})
      },
      query: _APIQuery2['default']({}),
      settings: {
        query: _APIQuery2['default']({})
      }
    },
    dictionary: {
      countries: {
        query: _APIQuery2['default']({})
      },
      employmentStatuses: {
        query: _APIQuery2['default']({})
      },
      industries: {
        query: _APIQuery2['default']({})
      }
    }
  }),
  patch: _immutable.fromJS({
    client: {
      additionalData: {
        query: _APIQuery2['default']({})
      },
      application: {
        check: {
          query: _APIQuery2['default']({})
        },
        query: _APIQuery2['default']({})
      },
      consents: {
        query: _APIQuery2['default']({})
      },
      emailConfirmation: {
        query: _APIQuery2['default']({})
      },
      password: {
        query: _APIQuery2['default']({})
      },
      phoneConfirmation: {
        query: _APIQuery2['default']({})
      },
      profile: {
        query: _APIQuery2['default']({})
      },
      settings: {
        query: _APIQuery2['default']({})
      }
    }
  }),
  send: _immutable.fromJS({
    client: {
      application: {
        query: _APIQuery2['default']({})
      },
      cookies: {
        query: _APIQuery2['default']({})
      },
      email: {
        query: _APIQuery2['default']({})
      },
      identityDocument: {
        query: _APIQuery2['default']({})
      },
      phone: {
        query: _APIQuery2['default']({})
      }
    },
    registration: {
      query: _APIQuery2['default']({})
    }
  })
});

var initialState = new InitialState();
var IS_API_ACTION = /^(DESTROY|FETCH|PATCH|SEND)/;
var IS_START = /_START$/;
var IS_SUCCESS = /_SUCCESS$/;
var IS_ERROR = /_ERROR$/;
var IS_RESET = /_RESET$/;

function apiReducer(state, action) {
  if (state === undefined) state = initialState;
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);
  if (!IS_API_ACTION.test(action.type)) return state;
  if (IS_START.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_START:
      return state.setIn(['fetch', 'application', 'constraints', 'query', 'pending'], true);

    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_START:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString(), 'pending'], true);

    case actions.FETCH_CLIENT_ADDITIONAL_DATA_START:
      return state.setIn(['fetch', 'client', 'additionalData', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_START:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_START:
      return state.setIn(['fetch', 'client', 'application', 'monthlyPayment', action.meta.amount.toString(), action.meta.term.toString(), 'pending'], true);

    case actions.FETCH_CLIENT_APPLICATION_OFFER_START:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString(), 'pending'], true);

    case actions.FETCH_CLIENT_APPLICATION_START:
      return state.setIn(['fetch', 'client', 'application', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_BANKS_START:
      return state.setIn(['fetch', 'client', 'banks', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_CONSENTS_START:
      return state.setIn(['fetch', 'client', 'consents', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_EMAIL_START:
      return state.setIn(['fetch', 'client', 'email', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_START:
      return state.setIn(['fetch', 'client', 'identityDocument', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_LOANS_BY_LOANID_START:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString(), 'pending'], true);

    case actions.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_START:
      return state.setIn(['fetch', 'client', 'loans', 'paymentSchedule', action.meta.loanId.toString(), 'pending'], true);

    case actions.FETCH_CLIENT_LOANS_START:
      return state.setIn(['fetch', 'client', 'loans', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_PHONE_START:
      return state.setIn(['fetch', 'client', 'phone', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_PROFILE_START:
      return state.setIn(['fetch', 'client', 'profile', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_SETTINGS_START:
      return state.setIn(['fetch', 'client', 'settings', 'query', 'pending'], true);

    case actions.FETCH_CLIENT_START:
      return state.setIn(['fetch', 'client', 'query', 'pending'], true);

    case actions.FETCH_DICTIONARY_COUNTRIES_START:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query', 'pending'], true);

    case actions.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_START:
      return state.setIn(['fetch', 'dictionary', 'employmentStatuses', 'query', 'pending'], true);

    case actions.FETCH_DICTIONARY_INDUSTRIES_START:
      return state.setIn(['fetch', 'dictionary', 'industries', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_ADDITIONAL_DATA_START:
      return state.setIn(['patch', 'client', 'additionalData', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_APPLICATION_CHECK_START:
      return state.setIn(['patch', 'client', 'application', 'check', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_APPLICATION_START:
      return state.setIn(['patch', 'client', 'application', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_CONSENTS_START:
      return state.setIn(['patch', 'client', 'consents', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_START:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_PASSWORD_START:
      return state.setIn(['patch', 'client', 'password', 'pending'], true);

    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_START:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_PROFILE_START:
      return state.setIn(['patch', 'client', 'profile', 'query', 'pending'], true);

    case actions.PATCH_CLIENT_SETTINGS_START:
      return state.setIn(['patch', 'client', 'settings', 'pending'], true);

    case actions.SEND_CLIENT_APPLICATION_START:
      return state.setIn(['send', 'client', 'application', 'query', 'pending'], true);

    case actions.SEND_CLIENT_COOKIES_START:
      return state.setIn(['send', 'client', 'cookies', 'query', 'pending'], true);

    case actions.SEND_CLIENT_EMAIL_START:
      return state.setIn(['send', 'client', 'email', 'pending'], true);

    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_START:
      return state.setIn(['send', 'client', 'identityDocument', 'pending'], true);

    case actions.SEND_CLIENT_PHONE_START:
      return state.setIn(['send', 'client', 'phone', 'pending'], true);

    case actions.SEND_REGISTRATION_START:
      return state.setIn(['send', 'registration', 'pending'], true);
  }
  if (IS_SUCCESS.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_SUCCESS:
      return state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_ADDITIONAL_DATA_SUCCESS:
      return state.setIn(['fetch', 'client', 'additionalData', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'monthlyPayment', action.meta.amount.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_OFFER_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_BANKS_SUCCESS:
      return state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_CONSENTS_SUCCESS:
      return state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_EMAIL_SUCCESS:
      return state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_SUCCESS:
      return state.setIn(['fetch', 'client', 'identityDocument', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', 'paymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_PHONE_SUCCESS:
      return state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_PROFILE_SUCCESS:
      return state.setIn(['fetch', 'client', 'profile', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_SETTINGS_SUCCESS:
      return state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_CLIENT_SUCCESS:
      return state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_COUNTRIES_SUCCESS:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_SUCCESS:
      return state.setIn(['fetch', 'dictionary', 'employmentStatuses', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_INDUSTRIES_SUCCESS:
      return state.setIn(['fetch', 'dictionary', 'industries', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_ADDITIONAL_DATA_SUCCESS:
      return state.setIn(['patch', 'client', 'additionalData', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_APPLICATION_CHECK_SUCCESS:
      return state.setIn(['patch', 'client', 'application', 'check', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_CONSENTS_SUCCESS:
      return state.setIn(['patch', 'client', 'consents', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PASSWORD_SUCCESS:
      return state.setIn(['patch', 'client', 'password'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PROFILE_SUCCESS:
      return state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.PATCH_CLIENT_SETTINGS_SUCCESS:
      return state.setIn(['patch', 'client', 'settings'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_CLIENT_COOKIES_SUCCESS:
      return state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_CLIENT_EMAIL_SUCCESS:
      return state.setIn(['send', 'client', 'email'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_SUCCESS:
      return state.setIn(['send', 'client', 'identityDocument'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_CLIENT_PHONE_SUCCESS:
      return state.setIn(['send', 'client', 'phone'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));

    case actions.SEND_REGISTRATION_SUCCESS:
      return state.setIn(['send', 'registration'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
  }
  if (IS_ERROR.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_ERROR:
      return state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_ADDITIONAL_DATA_ERROR:
      return state.setIn(['fetch', 'client', 'additionalData', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'monthlyPayment', action.meta.amount.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_APPLICATION_OFFER_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_BANKS_ERROR:
      return state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_CONSENTS_ERROR:
      return state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_EMAIL_ERROR:
      return state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_ERROR:
      return state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_ERROR:
      return state.setIn(['fetch', 'client', 'identityDocument', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_BY_LOANID_ERROR:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_ERROR:
      return state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_ERROR:
      return state.setIn(['fetch', 'client', 'loans', 'paymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_PHONE_ERROR:
      return state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_PROFILE_ERROR:
      return state.setIn(['fetch', 'client', 'profile', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_CLIENT_SETTINGS_ERROR:
      return state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_COUNTRIES_ERROR:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_ERROR:
      return state.setIn(['fetch', 'dictionary', 'employmentStatuses', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.FETCH_DICTIONARY_INDUSTRIES_ERROR:
      return state.setIn(['fetch', 'dictionary', 'industries', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_ADDITIONAL_DATA_ERROR:
      return state.setIn(['patch', 'client', 'additionalData', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_APPLICATION_CHECK_ERROR:
      return state.setIn(['patch', 'client', 'application', 'check', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_APPLICATION_ERROR:
      return state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_CONSENTS_ERROR:
      return state.setIn(['patch', 'client', 'consents', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PASSWORD_ERROR:
      return state.setIn(['patch', 'client', 'password'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_ERROR:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_PROFILE_ERROR:
      return state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.PATCH_CLIENT_SETTINGS_ERROR:
      return state.setIn(['patch', 'client', 'settings'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_CLIENT_APPLICATION_ERROR:
      return state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_CLIENT_COOKIES_ERROR:
      return state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_CLIENT_EMAIL_ERROR:
      return state.setIn(['send', 'client', 'email'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_ERROR:
      return state.setIn(['send', 'client', 'identityDocument'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_CLIENT_PHONE_ERROR:
      return state.setIn(['send', 'client', 'phone'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));

    case actions.SEND_REGISTRATION_ERROR:
      return state.setIn(['send', 'registration'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
  }
  if (IS_RESET.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'constraints', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_ADDITIONAL_DATA_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'additionalData', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'additionalData', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'constraints', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'monthlyPayment', action.meta.amount.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'monthlyPayment', action.meta.amount.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_APPLICATION_OFFER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_BANKS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'banks', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'bankAccountNumber', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_CONSENTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'consents', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_EMAIL_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'email', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'identityDocument', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'identityDocument', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_LOANS_BY_LOANID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', 'paymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', 'paymentSchedule', action.meta.loanId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_LOANS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_PHONE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'phone', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_PROFILE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'profile', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'profile', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_CLIENT_SETTINGS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'settings', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_DICTIONARY_COUNTRIES_RESET:
      return action.hardReset ? state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'dictionary', 'countries', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET:
      return action.hardReset ? state.setIn(['fetch', 'dictionary', 'employmentStatuses', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'dictionary', 'employmentStatuses', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.FETCH_DICTIONARY_INDUSTRIES_RESET:
      return action.hardReset ? state.setIn(['fetch', 'dictionary', 'industries', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'dictionary', 'industries', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_ADDITIONAL_DATA_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'additionalData', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'additionalData', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_APPLICATION_CHECK_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'application', 'check', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'application', 'check', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_CONSENTS_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'consents', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'consents', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'emailConfirmation', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_PASSWORD_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'password'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'password'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'phoneConfirmation', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_PROFILE_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'profile', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.PATCH_CLIENT_SETTINGS_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'settings'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'settings'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_CLIENT_COOKIES_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'cookies', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_CLIENT_EMAIL_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'email'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'email'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'identityDocument'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'identityDocument'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_CLIENT_PHONE_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'phone'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'phone'], {
        fetched: false,
        pending: false,
        errors: null
      });

    case actions.SEND_REGISTRATION_RESET:
      return action.hardReset ? state.setIn(['send', 'registration'], _APIQuery2['default']({})) : state.mergeIn(['send', 'registration'], {
        fetched: false,
        pending: false,
        errors: null
      });
  }
  return state;
}

module.exports = exports['default'];